/**
 * Term Sheet is a panel-only section of the OPS write-up: it has no
 * `OpsWriteupSectionKey` because there is no `commentary_section` behind it, so
 * it keys off this literal in the section registry, the tab bar and the
 * `#section-<key>` anchor the retired `/manage-terms` route forwards to. Kept
 * out of the registry module so the router can link to the anchor without
 * eagerly pulling in every Deal Summary section component.
 */
export const TERM_SHEET_SECTION_KEY = 'TERM_SHEET'
